import type { WalletMonitoringKind } from '@shared/api/contracts/wallet-monitoring';
import type { ServiceOpType, WalletKind } from '../model/types';

export const SERVICE_OPERATION_TYPES: readonly ServiceOpType[] = [
  'deposit',
  'withdraw',
  'exchange',
  'transfer',
  'expense',
  'refund',
  'adjustment',
] as const;

export const SERVICE_WALLET_KINDS: readonly WalletKind[] = [
  'working',
  'deposit',
  'payout',
  'service',
] as const;

/** Kinds for GET /wallets when loading options for manual service accounting operations. */
export const OPERATION_WALLET_QUERY_KINDS: readonly WalletMonitoringKind[] = [
  ...SERVICE_WALLET_KINDS,
  'other',
];
